import editorSchema from './editorSchema'
import settingsSchema from './settingsSchema'

const schema = (isWrittenContent = false) =>
  editorSchema.concat(settingsSchema(isWrittenContent))

export default schema
